import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
  //Notification,
  //Notification,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  // Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  MoreVertical,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
//import { showToast } from "../common/UtilityHelper";
import Canceldemo from "./Canceldemo";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  logAccess,
  debugLog,
} from "./GlobalSettings";
import StaticTypeDemoDisplay from "./StaticTypeDemoDisplay";
import { Event } from "@material-ui/icons";
import UpdateExtensionMessage from "./UpdateExtensionMessage";
import ExtendDemoQuestion from "./ExtendDemoQuestion";
import StaticClickDemoFrame from "./StaticClickDemoFrame";
import TMEAddSeatsOverlay from "./TMEAddSeatsOverlay";
import Alert from "@material-ui/lab/Alert";
//import { Alert } from "@material-ui/core";
import { isThisSecond } from "date-fns";
import TmeCRSeatlst from "./TmeCRSeatlst";
//import DemoLaunchInfo from "./DemoLaunchInfo";

class UpcomingEvtDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bdispCancel: false,
      UserInfo: auth.getUserInfo(),
      UserActions: auth.getUserActions(),
      demoType: "",
      _NoExtUpdateMessage: undefined,
      isDownTimeType: false,
      _extNotsuccess: false,
      isdemoValid: false,
      LaunchInfo: undefined,
      bshowSpinner: true,
      ShowDemoLaunchLayer: false,
      showStaticTypeInfo: false,
      showMistAppMsg: false,
      _extendeEvtRec: undefined,
      extUpdateMessage: undefined,
      extUpdateSuccess: false,
      extUpdateLoader: false,
      extensionTriggered: false,
      isStaticClickinFrame: false,
      isAddSeatsClicked: false,
      isDisplayCRSeatsClicked: false,
      isretValFromAddSeats: false,
      isretValFromAddSeatsNO: false,
    };

    this._ShowCancel = this._ShowCancel.bind(this);
    // this.reLoadEventBasics = this.reLoadEventBasics.bind(this);
    this.diff_hours = this.diff_hours.bind(this);
    this._loadVRNetLaunchInfo = this._loadVRNetLaunchInfo.bind(this);
    this._launchEventRequested = this._launchEventRequested.bind(this);
    this._hideStaticDisplayScr = this._hideStaticDisplayScr.bind(this);
    this._downloadPdf = this._downloadPdf.bind(this);
    this.extendDemoTime = this.extendDemoTime.bind(this);
    this.submitData = this.submitData.bind(this);
    this.closeExtMesssenger = this.closeExtMesssenger.bind(this);
    this._handleExtendClick = this._handleExtendClick.bind(this);
    this._handleCallBackYes = this._handleCallBackYes.bind(this);
    this._handleCallBackNo = this._handleCallBackNo.bind(this);
    this._closeStaticClickDisplay = this._closeStaticClickDisplay.bind(this);
    this.SetExtToastClose = this.SetExtToastClose.bind(this);
    this._handleShowSeatsClick = this._handleShowSeatsClick.bind(this);
    this._handleAddSeatClick = this._handleAddSeatClick.bind(this);
    this._hideTMESeatOverlay = this._hideTMESeatOverlay.bind(this);
    this._hideShowSeatsOverlay = this._hideShowSeatsOverlay.bind(this);
    this._backFromTMEOverlaywithYes =
      this._backFromTMEOverlaywithYes.bind(this);
    this._backFromTMEOverlaywithNo = this._backFromTMEOverlaywithNo.bind(this);
    this.onSuccessSeatAddedClose = this.onSuccessSeatAddedClose.bind(this);
    this.onFailureSeatAddedClose = this.onFailureSeatAddedClose.bind(this);
    this.onMistInviteClick = this.onMistInviteClick.bind(this);
  }

  componentDidMount() {
    this._loadVRNetLaunchInfo();
    if (
      this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === null ||
      this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 1
    ) {
      this.setState({ demoType: "VRNET" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 3) {
      this.setState({ demoType: "TME_LABS" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 4) {
      this.setState({ demoType: "EDGE_LINE" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 5) {
      this.setState({ demoType: "STATIC_TYPE" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 6) {
      this.setState({ demoType: "STATIC_CLICK" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 7) {
      this.setState({ demoType: "HACKSHACK" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 8) {
      this.setState({ demoType: "TME_INDIVIDUAL" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 10) {
      this.setState({ demoType: "TA_OKTA" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 11) {
      this.setState({ demoType: "GL_APP" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 12) {
      this.setState({ demoType: "OpsR_APP" });
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 13) {
      this.setState({ demoType: "Mist_APP" });
    }
    this._evtInterval = setInterval(() => {
      console.log("Interval started!");
      this._loadVRNetLaunchInfo();
    }, 30000);

    if (this.props.Evt.Event_Type.EventType_Name === "Downtime") {
      this.setState({ isDownTimeType: true });
    }
  }

  componentWillUnmount() {
    clearInterval(this._evtInterval);
  }

  closeExtMesssenger() {
    this.setState({
      extUpdateLoader: false,
      extUpdateSuccess: false,
      extensionTriggered: false,
    });
  }

  onMistInviteClick(val) {
    var notVal = !val;
    this.setState({ showMistAppMsg: notVal });
    //set show mist invite message
  }

  _handleAddSeatClick() {
    this.setState({ isAddSeatsClicked: true });
  }

  _handleExtendClick() {
    this.setState({ extensionTriggered: true, _extNotsuccess: false });
  }

  _handleShowSeatsClick() {
    this.setState({ isDisplayCRSeatsClicked: true });
    /* window.open(
      "https://app.powerbi.com/groups/472bb649-6d79-446b-bcc9-3a5717ca670a/reports/45f5ffc5-8a51-462c-bc69-6d4adf4c4172/ReportSection3272fd4ac223c06ee918?ctid=105b2061-b669-4b31-92ac-24d304d195dc",
      "_blank"
    ); */
  }

  _hideShowSeatsOverlay() {
    this.setState({ isDisplayCRSeatsClicked: false });
  }

  _handleCallBackYes() {
    this.extendDemoTime();
  }

  _hideTMESeatOverlay() {
    this.setState({ isAddSeatsClicked: false });
  }
  _backFromTMEOverlaywithYes() {
    this.setState({ isretValFromAddSeats: true });
    this._hideTMESeatOverlay();
    console.log("Yeah Yeah Hippy Hippy Yeah Yeah Yeah");
  }
  _backFromTMEOverlaywithNo() {
    this.setState({ isretValFromAddSeatsNO: true });
    this._hideTMESeatOverlay();
    console.log("Dil Ke Armaan Aansuoo Mein Beh Gaye");
  }

  _closeStaticClickDisplay() {
    this.setState({ isStaticClickinFrame: false });
  }

  SetExtToastClose() {
    this.setState({ _extNotsuccess: false });
  }

  _handleCallBackNo() {
    this.setState({ extensionTriggered: false });
  }

  onSuccessSeatAddedClose() {
    this.setState({ isretValFromAddSeats: false });
  }

  onFailureSeatAddedClose() {
    this.setState({ isretValFromAddSeatsNO: false });
  }

  extendDemoTime() {
    this.setState({ extUpdateLoader: true });
    const extendedHours = 2;
    var existEventRecord = this.props.Evt;
    var existingEndDate = this.props.Evt.Event_EndDate;

    //Duration_ID": "2.0:0",
    var dt = new Date(existingEndDate);
    console.log("Existing EndDate", existingEndDate);
    dt.setHours(dt.getHours() + extendedHours);
    var updatedDate = dt;
    console.log("Updated Date", updatedDate);
    existEventRecord.Event_EndDate = updatedDate;
    // split duration
    var splitEventDuration =
      this.props.Evt.Event_Duration && this.props.Evt.Event_Duration.Duration_ID
        ? this.props.Evt.Event_Duration.Duration_ID.split(".")
        : [0, "0:0"];
    //var durationMilliseconds = (splitEventDuration[0] * 24 * 60 * 60 * 1000) + (splitEventDuration[1].split(':')[0] * 60 * 60 * 1000)  + (splitEventDuration[1].split(':')[1] * 60 * 1000);

    var splitEventDays = splitEventDuration[0];
    var splitEventHours = splitEventDuration[1].split(":")[0];
    var splitEventMins = splitEventDuration[1].split(":")[1];

    // add extended hours for not multidays
    if (splitEventDays === "0") {
      splitEventHours = parseInt(splitEventHours) + 2;
    }

    // append String
    var updatedDuration =
      splitEventDays + "." + splitEventHours + ":" + splitEventMins;
    //console.log("updatedDuration",updatedDuration);
    // update duration
    existEventRecord.Event_Duration.Duration_ID = updatedDuration;

    var duration_name;
    switch (updatedDuration) {
      case "0.1:30":
        duration_name = "1 Hour 30 Minutes";
        break;
      case "0.2:0":
        duration_name = "1 Hour 30 Minutes";
        break;
      case "0.2:30":
        duration_name = "2 Hours 30 Minutes";
        break;
      case "0.3:0":
        duration_name = "3 Hours";
        break;
      case "0.3:30":
        duration_name = "3 Hours 30 Minutes";
        break;
      case "0.4:0":
        duration_name = "4 Hours";
        break;
      case "0.4:30":
        duration_name = "4 Hours 30 Minutes";
        break;
      case "0.5:0":
        duration_name = "5 Hours";
        break;
      case "0.5:30":
        duration_name = "5 Hours 30 Minutes";
        break;
      case "0.6:0":
        duration_name = "6 Hours";
        break;
      case "0.6:30":
        duration_name = "6 Hours 30 Minutes";
        break;
      case "0.7:0":
        duration_name = "7 Hours";
        break;
      case "0.7:30":
        duration_name = "7 Hours 30 Minutes";
        break;
      case "0.8:0":
        duration_name = "8 Hours";
        break;
    }
    existEventRecord.Event_Duration.Duration_ID = updatedDuration;
    existEventRecord.Event_Duration.Duration_Name = duration_name;
    existEventRecord.Is_Extension = true;
    /*  this.setState({
      _extendeEvtRec:existEventRecord
    }) */
    //console.log("****Updated Record***",existEventRecord);
    this.submitData(existEventRecord);
  }

  submitData(record) {
    var endpoint = "/Events/UpdateEvent";
    let token = auth.getToken();
    callApiPostJson(endpoint, record, token).then((data) => {
      console.log("Response:");
      this.setState({ submittingData: false });
      console.log(data);
      if (
        data &&
        data.UpdateMessage &&
        data.UpdateMessage[0].indexOf("Success") > 0 &&
        data.UpdateMessage[0].indexOf("error") < 1
      )
        //this.props.onClose("Successfully Submitted Event Request ID: " + data.Event_ID);
        this.setState({
          extUpdateMessage:
            "Successfully extended the demo for another 2 hours ",
          extUpdateSuccess: true,
          extUpdateLoader: false,
          _extendeEvtRec: record,
        });
      else if (
        data &&
        data.UpdateMessage &&
        data.UpdateMessage[0].indexOf("missing physical environment") > 0
      )
        this.setState({
          extUpdateMessage: "Requested Date/Time not available.",
          extUpdateSuccess: false,
          extUpdateLoader: false,
        });
      else if (
        data &&
        data.UpdateMessage &&
        data.UpdateMessage[0].indexOf("for extension") > 0
      )
        this.setState({
          _NoExtUpdateMessage:
            "No Lab or Timeslot available for extension at this time",
          _extNotsuccess: true,
          extUpdateSuccess: false,
          extensionTriggered: false,
          extUpdateLoader: false,
        });
      else if (
        data &&
        data.UpdateMessage &&
        data.UpdateMessage[0].indexOf(
          "email selected does not exist in our system",
        ) > 0
      )
        this.setState({
          extUpdateMessage: "Presenter email not found in system",
          extUpdateSuccess: false,
          extUpdateLoader: false,
        });
      else if (data && data.ErrorMessage)
        this.setState({
          extUpdateMessage: data.ErrorMessage,
          extUpdateSuccess: false,
          extUpdateLoader: false,
        });
      else
        this.setState({
          extUpdateMessage: "Unspecified error saving Event.",
          extUpdateSuccess: false,
          extUpdateLoader: false,
        });
    });
  }

  _downloadPdf(event) {
    event.stopPropagation();

    var dmeoguideId = this.props.Evt.PhysicalContents.DemoGuide_ID;

    var endpoint = "/DocContent/GetDocAccessToken/" + dmeoguideId; // contentRecord.Content_ID;
    let token = auth.getToken();

    callApiGetJson(endpoint, token).then((data) => {
      if (data !== undefined) {
        debugLog(data);
        var elem = window.document.createElement("a");
        elem.href = APIServerURL + "/DocContent/GetDocByToken/" + data.Token;
        elem.target = "_blank";
        elem.download = dmeoguideId + "." + "pdf";
        //contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    });

    //this just refreshes the user token if necessary
    auth.verifyToken(true);
    logAccess(
      dmeoguideId,
      //this.props._demoData.Content_ID,
      "Document",
      // this.props._demoData.Content_Type,
      "DemoGuideDownloaded",
      "FromMyDemos",
      token,
    );
  }

  _hideStaticDisplayScr() {
    this.setState({ showStaticTypeInfo: false });
  }

  _launchEventRequested(event) {
    event.stopPropagation();
    console.log("LaunchEvt Fired");
    if (
      this.state.demoType === "VRNET" ||
      this.state.demoType === "TME_LABS" ||
      this.state.demoType === "TME_INDIVIDUAL" ||
      this.state.demoType === "HACKSHACK" ||
      this.state.demoType === "EDGE_LINE"
    ) {
      var elem = window.document.getElementById(
        "Launch_" + this.props.Evt.Event_ID,
      );
      console.log("Element captured is ", elem);
      elem.submit();
    } else if (this.state.demoType === "STATIC_CLICK") {
      if (!this.props.Evt.PhysicalEquipment.Static_Click_DisplayWindow) {
        this.setState({ isStaticClickinFrame: true });
      } else {
        window.open(this.props.Evt.PhysicalEquipment.StaticEnv_Url, "_blank");
      }
    } else if (this.state.demoType === "TA_OKTA") {
      window.open(this.props.Evt.Event_TAOKTA_Url, "_blank");
    } else if (this.state.demoType === "GL_APP") {
      window.open(this.props.Evt.GLApp_URL, "_blank");
    } else if (this.state.demoType === "OpsR_APP") {
      window.open(this.props.Evt.OpsRampApp_URL, "_blank");
      // } else if (this.state.demoType === "Mist_APP") {
      //   this.setState({ showMistAppMsg: true });
    } else {
      if (this.state.demoType === "STATIC_TYPE") {
        this.setState({ showStaticTypeInfo: true });
      }
    }
    //var elem = window.document.getElementById('Launch_' + eventRecord.Event_ID);
    //VrnetInfo={this.state.VRNetLaunchData};
    // this.loadVRNetLaunchInfo();
    //this.setState({ ShowDemoLaunchLayer: true });
  }

  _loadVRNetLaunchInfo() {
    var endpoint = "/Events/GetVRNetLaunchInfo";
    let token = auth.getToken();
    callApiGetJson(endpoint, token).then((data) => {
      //console.log('VRNetLaunchinf data from API:', data);
      this.setState({
        LaunchInfo: data,
        bshowSpinner: false,
      });
    });
  }

  diff_hours(dt2, dt1) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60 * 60;
    var diffHours = Math.abs(diff);
    //console.log(diffHours);
    return diffHours;
  }

  /*   reLoadEventBasics() {
    this.setState({ LaunchInfo: this.props.LaunchData });
    if (
      this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === null ||
      this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 1
    ) {
      if (
        this.props.Evt.Event_Presenter &&
        this.props.Evt.Event_Status.EventStatus_Name === "Approved"
      ) {
        this.setState({ demoType: "VRNET", isdemoValid: true });
      }
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 3) {
      if (
        this.props.Evt.Event_Presenter &&
        this.props.Evt.Event_Status.EventStatus_Name === "Approved"
      ) {
        this.setState({ demoType: "TMELAB", isdemoValid: true });
      }
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 4) {
      if (
        this.props.Evt.Event_Presenter &&
        this.props.Evt.Event_Status.EventStatus_Name === "Approved"
      ) {
        this.setState({ demoType: "EDGELINE", isdemoValid: true });
      }
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 5) {
      if (
        this.props.Evt.Event_Presenter &&
        this.props.Evt.Event_Status.EventStatus_Name === "Approved"
      ) {
        this.setState({ demoType: "STATIC-TYPE", isdemoValid: true });
      }
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 6) {
      if (
        this.props.Evt.Event_Presenter &&
        this.props.Evt.Event_Status.EventStatus_Name === "Approved"
      ) {
        this.setState({ demoType: "STATIC-CLICK", isdemoValid: true });
      }
    }
    if (this.props.Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 7) {
      if (
        this.props.Evt.Event_Presenter &&
        this.props.Evt.Event_Status.EventStatus_Name === "Approved"
      ) {
        this.setState({ demoType: "HACKSHACK", isdemoValid: true });
      }
    }
  } */

  _ShowCancel() {
    this.setState({ bdispCancel: true });
  }

  render() {
    //this.reLoadEventBasics();

    var isDownTime =
      this.props.Evt.Event_Type.EventType_Name === "Downtime" ? true : false;
    console.log("Is Event Type is DownTime Type ", isDownTime);

    console.log(
      "Return Val From Add TME CR seats is YES or SUCCESS ",
      this.state.isretValFromAddSeats,
    );
    console.log(
      "Return Val From Add TME CR seats is NO or FAILED ",
      this.state.isretValFromAddSeatsNO,
    );

    var isAddSeatPassed = this.state.isretValFromAddSeats
      ? this.state.isretValFromAddSeats
      : false;
    var isAddSeatFailed = this.state.isretValFromAddSeatsNO
      ? this.state.isretValFromAddSeatsNO
      : false;

    var spinnercontent = "";
    // var extensionnot = "";
    console.log(
      "DemoLaunchInfo From State in UserEvtView is ",
      this.state.LaunchInfo,
    );

    console.log(" Event is ", this.props.Evt);

    var isMistAppReadyLaunch = this.state.showMistAppMsg ? true : false;

    //var Gateway_url = "https://gva1-gateway.hpevrnet.com/login";

    var Gateway_url = this.props.Evt.Gateway_Url
      ? this.props.Evt.Gateway_Url
      : "https://gva-access.hpevrnet.com/cgi/login";

    var StaticInfoLayerShow = this.state.showStaticTypeInfo;
    var ISNoDemoGuideAvailable =
      this.props.Evt.PhysicalContents &&
      this.props.Evt.PhysicalContents.DemoGuide_ID
        ? false
        : true;
    //this.state.LaunchInfo
    //? this.state.LaunchInfo.Gateway_Url
    // : "";
    var VRNetUid = this.state.LaunchInfo
      ? this.state.LaunchInfo.VRNetUsername
      : "";
    var VRNetPassword = this.state.LaunchInfo
      ? this.state.LaunchInfo.VRNetPassword
      : "";
    var Hackshack_url = this.state.LaunchInfo
      ? this.state.LaunchInfo.Hackshack_url
      : "";
    var Hackshack_Uid = this.state.LaunchInfo
      ? this.state.LaunchInfo.Hackshack_username
      : "";
    var Hackshack_Pwd = this.state.LaunchInfo
      ? this.state.LaunchInfo.Hackshack_pwd
      : "";

    var _Evt = undefined;
    //var isSeatNotOK = false;
    var bCancelPopDisplay = this.state.bdispCancel;
    //var bLaunchEvt = this.state.ShowDemoLaunchLayer;
    //var DemoT = this.state.demoType;

    if (this.props.Evt) {
      _Evt = this.props.Evt;
    }

    var noextsuccess = this.state._extNotsuccess
      ? this.state._extNotsuccess
      : false;
    console.log("Tme INdi Extension not succeded", noextsuccess);

    var noextUpdatemsg = this.state._NoExtUpdateMessage;
    console.log("Tme INdi Extension not succeded message", noextUpdatemsg);

    /*  if (
      noextsuccess &&
      noextUpdatemsg == "No time slot or lab available for this extension"
    ) {
      showToast({
        message: "No time slot or lab available for this extension",
        intent: "danger",
      });
    } */

    var _LaunchData = this.state.LaunchInfo ? this.state.LaunchInfo : undefined;

    var isSeatOK = _Evt.Is_SeatOK ? _Evt.Is_SeatOK : false;

    var startDateObject = _Evt.Event_StartDate
      ? new Date(_Evt.Event_StartDate)
      : null;
    var endDateObject = _Evt.Event_EndDate
      ? new Date(_Evt.Event_EndDate)
      : null;
    var isDemoActive = false;
    // var isDemoValid = this.state.isdemoValid ? this.state.isdemoValid : false;
    var isTMEDemo =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 3 ? true : false;
    var isTMEIndividual =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 8 ? true : false;
    var isHACKShackDemo =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 7 ? true : false;
    // var isDemoCancelled = this.state.demoType === "TMELAB" ? true : false ;
    var isEdgeDemo =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 4 ? true : false;
    var isStaticDemo =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 5 ? true : false;
    var isStaticClickDemo =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 6 ? true : false;
    var isVRNETDemo =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === null ||
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 1
        ? true
        : false;
    var isTMEClassroom =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 9 ? true : false;
    var isTA_OKTA =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 10 ? true : false;
    // var isDefaultDemo=false;
    var isGL_APP =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 11 ? true : false;
    var isOpsRamp_APP =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 12 ? true : false;
    var isMist_APP =
      _Evt.PhysicalEquipment.EnvironmentType.EvnType_ID === 13 ? true : false;

    var isDemoValid =
      _Evt.Event_Status.EventStatus_Name === "Approved" ? true : false;
    var diffHours;
    var multiday = true;
    if (_Evt.Event_Duration.Duration_Name.indexOf("Day") < 0) {
      multiday = false;
    } else if (_Evt.Event_Duration.Duration_Name.indexOf("Day") >= 0) {
      multiday = true;
    }
    if (endDateObject !== null && multiday === false) {
      diffHours = this.diff_hours(new Date(), endDateObject);
    }

    console.log("Gateway URL is ", Gateway_url);
    var _hiddenForms = (
      <div>
        {this.state.demoType === "VRNET" ? (
          <form
            style={{ width: "100%" }}
            action={Gateway_url}
            id={"Launch_" + this.props.Evt.Event_ID}
            target="_blank"
            method="post"
          >
            <input type="hidden" name="login" value={VRNetUid} />
            <input type="hidden" name="passwd" value={VRNetPassword} />
            {/*             <div style={{ padding: "12px", marginLeft: "201px" }}>
            <Button
              label="OK"
              onClick={(event) => {
                that._launchevent(this.props.DemoEvent.Event_ID, event);
              }}
              type="submit"
            />
          </div> */}
          </form>
        ) : (
          <span></span>
        )}

        {this.state.demoType === "HACKSHACK" ? (
          <form
            style={{ width: "100%" }}
            action={Hackshack_url}
            id={"Launch_" + this.props.Evt.Event_ID}
            target="_blank"
            method="post"
          >
            <input
              type="hidden"
              id="username_input"
              name="username"
              value={Hackshack_Uid}
            />
            <input
              type="hidden"
              id="password_input"
              name="password"
              value={Hackshack_Pwd}
            />
            {/*             <div style={{ padding: "12px", marginLeft: "201px" }}>
            <Button
              label="OK"
              onClick={(event) => {
                that._launchevent(this.props.DemoEvent.Event_ID, event);
              }}
              type="submit"
            />
          </div> */}
          </form>
        ) : (
          <span></span>
        )}

        {this.state.demoType === "EDGE_LINE" ? (
          <form
            style={{ width: "100%" }}
            action={this.props.Evt.Event_TME_BaseUrl}
            id={"Launch_" + this.props.Evt.Event_ID}
            target="_blank"
            method="post"
          >
            <input
              type="hidden"
              name="login"
              value={this.props.Evt.Event_TME_UserId}
            />
            <input
              type="hidden"
              name="passwd"
              value={this.props.Evt.Event_TMEPwd}
            />
            {/*             <div style={{ padding: "12px", marginLeft: "201px" }}>
            <Button
              label="OK"
              onClick={(event) => {
                that._launchevent(this.props.DemoEvent.Event_ID, event);
              }}
              type="submit"
            />
          </div> */}
          </form>
        ) : (
          <span></span>
        )}

        {this.state.demoType === "TME_LABS" ? (
          <form
            style={{ width: "100%" }}
            action={this.props.Evt.Event_TME_BaseUrl}
            id={"Launch_" + this.props.Evt.Event_ID}
            target="_blank"
            method="post"
          >
            <input
              type="hidden"
              name="username"
              value={this.props.Evt.Event_TME_UserId}
            />
            <input
              type="hidden"
              name="password"
              value={this.props.Evt.Event_TMEPwd}
            />
            <input
              type="hidden"
              name="realm"
              value={this.props.Evt.Event_TME_Realm}
            />
            {/*             <div style={{ padding: "12px", marginLeft: "201px" }}>
            <Button
              label="OK"
              onClick={(event) => {
                that._launchevent(this.props.DemoEvent.Event_ID, event);
              }}
              type="submit"
            />
          </div> */}
          </form>
        ) : (
          <span></span>
        )}

        {this.state.demoType === "TME_INDIVIDUAL" &&
        this.props.Evt.Event_TME_Realm === "TME_LABS" ? (
          <form
            style={{ width: "100%" }}
            action={this.props.Evt.Event_TME_BaseUrl}
            id={"Launch_" + this.props.Evt.Event_ID}
            target="_blank"
            method="post"
          >
            <input
              type="hidden"
              name="username"
              value={this.props.Evt.Event_TME_UserId}
            />
            <input
              type="hidden"
              name="password"
              value={this.props.Evt.Event_TMEPwd}
            />
            <input
              type="hidden"
              name="realm"
              value={this.props.Evt.Event_TME_Realm}
            />
            {/*             <div style={{ padding: "12px", marginLeft: "201px" }}>
            <Button
              label="OK"
              onClick={(event) => {
                that._launchevent(this.props.DemoEvent.Event_ID, event);
              }}
              type="submit"
            />
          </div> */}
          </form>
        ) : (
          <span></span>
        )}

        {this.state.demoType === "TME_INDIVIDUAL" &&
        this.props.Evt.Event_TME_Realm === "VRNET" ? (
          <form
            style={{ width: "100%" }}
            action={this.props.Evt.Event_TME_BaseUrl}
            id={"Launch_" + this.props.Evt.Event_ID}
            target="_blank"
            method="post"
          >
            <input
              type="hidden"
              name="login"
              value={this.props.Evt.Event_TME_UserId}
            />
            <input
              type="hidden"
              name="passwd"
              value={this.props.Evt.Event_TMEPwd}
            />
            {/*             <div style={{ padding: "12px", marginLeft: "201px" }}>
            <Button
              label="OK"
              onClick={(event) => {
                that._launchevent(this.props.DemoEvent.Event_ID, event);
              }}
              type="submit"
            />
          </div> */}
          </form>
        ) : (
          <span></span>
        )}
      </div>
    );

    if (_LaunchData) {
      console.log("Hidden forms are", _hiddenForms);
      if (isVRNETDemo) {
        if (
          _LaunchData.VRNetUsername &&
          _LaunchData.VRNetPassword &&
          _LaunchData.VRNetAccountActive
        ) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isTMEDemo) {
        if (
          _Evt.Event_TME_BaseUrl &&
          _Evt.Event_TME_UserId &&
          _Evt.Event_TMEPwd &&
          _Evt.Event_TME_Realm
        ) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isTMEIndividual) {
        if (
          _Evt.Event_TME_BaseUrl &&
          _Evt.Event_TME_UserId &&
          _Evt.Event_TMEPwd &&
          _Evt.Event_TME_Realm
        ) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isEdgeDemo) {
        if (
          _Evt.Event_TME_BaseUrl &&
          _Evt.Event_TME_UserId &&
          _Evt.Event_TMEPwd
        ) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isStaticDemo) {
        if (
          _Evt.PhysicalEquipment.StaticEnv_Url &&
          _Evt.PhysicalEquipment.StaticEnv_UserId &&
          _Evt.PhysicalEquipment.StaticEnv_Password
        ) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isStaticClickDemo) {
        if (_Evt.PhysicalEquipment.StaticEnv_Url) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isHACKShackDemo) {
        if (
          _LaunchData.Hackshack_url &&
          _LaunchData.Hackshack_username &&
          _LaunchData.Hackshack_pwd
        ) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isTA_OKTA) {
        if (_Evt.Event_TAOKTA_Url) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isGL_APP) {
        if (_Evt.GLApp_URL && _Evt.Is_GLApp_Creation_Success) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isOpsRamp_APP) {
        // Here need to write logic to make demo active for launch enabled or not
        if (_Evt.OpsRampApp_URL && _Evt.Is_OpsRamp_App_Creation_Success) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }
      if (isMist_APP) {
        if (_Evt.Is_Mist_App_Creation_Success) {
          if (startDateObject < new Date() && endDateObject > new Date()) {
            isDemoActive = true;
          } else {
            isDemoActive = false;
          }
        } else {
          isDemoActive = false;
        }
      }

      if (isTMEClassroom) {
        // if (startDateObject < new Date() && endDateObject > new Date()) {
        isDemoActive = true;
        // } else {
        //   isDemoActive = false;
        // }
      }
    }

    var extMessage = this.state.extUpdateMessage;
    var extStatus = this.state.extUpdateSuccess;
    var bToShowExtMessage =
      this.state.extUpdateSuccess && this.state.extUpdateMessage ? true : false;

    if (this.state.extUpdateLoader) {
      spinnercontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Your Demo-Event extension in progress...</Text>
          </Box>
        </Layer>
      );
    }

    /*     if (this.state._extNotsuccess) {
      extensionnot = (
        <Notification
          status="critical"
          title="Extension Update !"
          message="No Lab or Timeslot available for extension"
          onClose={this.SetExtToastClose}
        ></Notification>
      );
    } */

    var _extendedDemoEvt = this.state._extendeEvtRec;
    var isExtensionTriggered = this.state.extensionTriggered;

    var isStaticClickToDisplayinFrame = this.state.isStaticClickinFrame;

    var isAddSeatsTME = this.state.isAddSeatsClicked
      ? this.state.isAddSeatsClicked
      : false;

    var isDisplayTMECRSeats = this.state.isDisplayCRSeatsClicked
      ? this.state.isDisplayCRSeatsClicked
      : false;

    return (
      <Card
        direction="column"
        pad="medium"
        background={{ color: "background" }}
      >
        <Box align="stretch" justify="start">
          {isMistAppReadyLaunch && (
            <Box
              direction="row"
              border={{ color: "brand", size: "small" }}
              pad="xsmall"
              margin="medium"
            >
              <Alert severity="success">
                {/* <AlertTitle>Success</AlertTitle> */}
                Invitation sent to {this.state.UserInfo.EmailAddress} by Juniper
                Mist Lab, please proceed with registration and account creation
                / email validation, then sign in using the received email.
                Please read Demo Guide to understand the process in detail.
                {/* <strong>
                <Anchor
                  label="check it out!"
                  onClick={this._handleShowSeatsClick}
                />
              </strong> */}
              </Alert>
            </Box>
          )}
          {isAddSeatPassed && !isAddSeatFailed && (
            <Alert severity="success">
              {/* <AlertTitle>Success</AlertTitle> */}
              Seat(s) Added succesfully for this demo-event —{" "}
              <strong>
                <Anchor
                  label="check it out!"
                  onClick={this._handleShowSeatsClick}
                />
              </strong>
            </Alert>
            /*                 <Notification
          toast
          title="Success"
          message="Seat(s) Added succesfully for this demo-event"
          onClose={this.onSuccessSeatAddedClose}
        /> */
          )}
          {isAddSeatFailed && !isAddSeatPassed && (
            <Alert severity="error">
              {/* <AlertTitle>Success</AlertTitle> */}
              Seat(s) can not be Added to this demo-event —{" "}
              <strong>sorry!</strong>
            </Alert>
            /*                 <Notification
          toast
          title="Success"
          message="Seat(s) Added succesfully for this demo-event"
          onClose={this.onFailureSeatAddedClose}
        /> */
          )}
          <Box align="stretch" justify="start" direction="column">
            <Grid
              columns={["small", "medium"]}
              gap="xxsmall"
              align="start"
              justify="start"
            >
              <Text>EventID</Text>
              <Text>{_Evt.Event_ID}</Text>
              <Text>Event Subject</Text>
              {isDownTime && (
                <Text color="red">
                  <b>
                    {_Evt.Event_Title + " - " + _Evt.Event_Type.EventType_Name}
                  </b>
                </Text>
              )}
              {!isDownTime && (
                <Text>
                  <b>{_Evt.Event_Title}</b>
                </Text>
              )}
              <Text>When</Text>
              <Text>
                <b>
                  {startDateObject
                    ? startDateObject.toString()
                    : _Evt.Event_StartDate}
                </b>
              </Text>
              <Text>Event Duration</Text>
              <Text>
                <b>
                  {_extendedDemoEvt && extMessage
                    ? _extendedDemoEvt.Event_Duration.Duration_Name
                    : _Evt.Event_Duration.Duration_Name}
                </b>
              </Text>
              <Text>Event Status</Text>
              <Text>
                <b>{_Evt.Event_Status.EventStatus_Name}</b>
              </Text>
            </Grid>
            <Box
              align="start"
              justify="between"
              direction="row"
              gap="small"
              responsive={false}
              pad="medium"
            >
              {isDisplayTMECRSeats && isTMEClassroom && (
                <TmeCRSeatlst
                  hide={this._hideShowSeatsOverlay}
                  evtID={this.props.Evt.Event_ID}
                  evtTitle={this.props.Evt.Event_Title}
                />
              )}
              {isAddSeatsTME && isTMEClassroom && (
                <TMEAddSeatsOverlay
                  hide={this._hideTMESeatOverlay}
                  Event={this.props.Evt}
                  isTMECR={isTMEClassroom}
                  backwithYes={this._backFromTMEOverlaywithYes}
                  backwithNo={this._backFromTMEOverlaywithNo}
                />
              )}
              {isStaticClickToDisplayinFrame && isStaticClickDemo && (
                <StaticClickDemoFrame
                  DemoUrl={this.props.Evt.PhysicalEquipment.StaticEnv_Url}
                  DemoTitle={this.props.Evt.Event_Title}
                  hide={this._closeStaticClickDisplay}
                />
              )}
              {isExtensionTriggered && (
                <ExtendDemoQuestion
                  yes={this._handleCallBackYes}
                  no={this._handleCallBackNo}
                />
              )}
              {spinnercontent}
              {noextsuccess && (
                <Button
                  label="No slot Available"
                  primary={false}
                  icon={<Clear />}
                  disabled={noextsuccess}
                  // onClick={this._handleExtendClick}
                />
              )}
              {isTMEClassroom && !isDownTime && (
                <Button
                  label="Add seats"
                  primary={false}
                  icon={<MoreVertical />}
                  color="brand"
                  onClick={this._handleAddSeatClick}
                />
              )}
              {!noextsuccess &&
                noextUpdatemsg == undefined &&
                !isTMEClassroom &&
                !isDownTime && (
                  <Button
                    label="extend (+2h)"
                    primary={false}
                    icon={<AddCircle />}
                    disabled={isHACKShackDemo || multiday}
                    onClick={this._handleExtendClick}
                  />
                )}
              {/* <Button label="Edit" primary={false} icon={<Edit />} /> */}
              <Button
                label="Cancel"
                primary={false}
                icon={<Trash />}
                onClick={this._ShowCancel}
              />
              {bCancelPopDisplay && (
                <Canceldemo hide={this.props.hideCancel} DemoToCancel={_Evt} />
              )}
              {isDemoActive &&
                isDemoValid &&
                !isTMEIndividual &&
                !isSeatOK &&
                !isTMEClassroom &&
                isMist_APP &&
                !isDownTime && (
                  <Button
                    label="Invitation"
                    primary
                    icon={<Console />}
                    onClick={(event) => {
                      this.onMistInviteClick(this.state.showMistAppMsg);
                    }}
                  />
                )}
              {isDemoActive &&
                isDemoValid &&
                !isTMEIndividual &&
                !isSeatOK &&
                !isTMEClassroom &&
                !isMist_APP &&
                !isDownTime && (
                  <Button
                    label="Launch"
                    primary
                    icon={<Console />}
                    onClick={(event) => {
                      this._launchEventRequested(event);
                    }}
                  />
                )}
              {isDemoActive &&
                isDemoValid &&
                isTMEIndividual &&
                isSeatOK &&
                !isTMEClassroom &&
                !isMist_APP &&
                !isDownTime && (
                  <Button
                    label="Launch"
                    primary
                    icon={<Console />}
                    onClick={(event) => {
                      this._launchEventRequested(event);
                    }}
                  />
                )}
              {/* {bLaunchEvt && (
                <DemoLaunchInfo
                  DemoEvent={_Evt}
                  DemoType={DemoT}
                  VrnetInfo={_LaunchData}
                />
              )} */}
              {_hiddenForms}
              {isDemoActive &&
                isDemoValid &&
                isTMEIndividual &&
                !isSeatOK &&
                !isTMEClassroom &&
                !isDownTime && (
                  <Button
                    label="Not Available.."
                    primary
                    icon={<Console />}
                    disabled={true}
                  />
                )}
              {!isDemoActive && isDemoValid && !isDownTime && (
                <Button
                  label="Coming soon.."
                  primary
                  icon={<Console />}
                  disabled={true}
                />
              )}
              {isDemoActive && isDemoValid && isTMEClassroom && !isDownTime && (
                <Button
                  label="SHOW SEATS"
                  primary
                  icon={<Console />}
                  onClick={this._handleShowSeatsClick}
                />
              )}
              {!isDemoActive && !isDemoValid && !isDownTime && (
                <Button
                  label="Approval needed.."
                  primary
                  icon={<Console />}
                  disabled={true}
                />
              )}
              <Button
                label="Demo guide"
                icon={<Download />}
                secondary
                onClick={(event) => this._downloadPdf(event)}
                disabled={ISNoDemoGuideAvailable}
              />
              {StaticInfoLayerShow && (
                <StaticTypeDemoDisplay
                  DemoName={_Evt.Event_Title}
                  StatUrl={_Evt.PhysicalEquipment.StaticEnv_Url}
                  StatUid={_Evt.PhysicalEquipment.StaticEnv_UserId}
                  StatPwd={_Evt.PhysicalEquipment.StaticEnv_Password}
                  hide={this._hideStaticDisplayScr}
                />
              )}
              {StaticInfoLayerShow &&
                isVRNETDemo &&
                _LaunchData &&
                _LaunchData.VRNetUsername &&
                _LaunchData.VRNetPassword &&
                _LaunchData.VRNetAccountActive && (
                  <StaticTypeDemoDisplay
                    DemoName={_Evt.Event_Title}
                    StatUrl={Gateway_url}
                    StatUid={_LaunchData.VRNetUsername}
                    StatPwd={_LaunchData.VRNetPassword}
                    hide={this._hideStaticDisplayScr}
                  />
                )}
              {bToShowExtMessage && (
                <UpdateExtensionMessage
                  success={extStatus}
                  UpdateMessage={extMessage}
                  hide={this.closeExtMesssenger}
                />
              )}
            </Box>
          </Box>
        </Box>
      </Card>
    );
  }
}

export default UpcomingEvtDisplay;
